import React from "react";
import ClassContainer from "./ClassContainer";
import { CLASSES_AND_SPECS } from "../../../lib/classes-and-specs";
import { Helmet } from "react-helmet-async";
import { EXPANSION, PATCH } from "../../../lib/wowHelpers";

const ClassSpecPageContainer = () => {
  const pageDescription = `U.GG has better data for smarter insights. Discover data-driven builds, from best Hero talents to BIS gear, for every Class and Spec in ${EXPANSION} ${PATCH}.`;

  return (
    <div className="wow-class-spec-content-container">
      <Helmet>
        <title>World of Warcraft Classes and Specs</title>
        <meta name="description" content={pageDescription} />
      </Helmet>
      <div className="image-wrap" />
      <img className="background-image" src="https://static.bigbrain.gg/wow/background-images/SpecClass_BGImage.jpg" />
      <div className="wow-class-spec-page">
        <div className="class-spec-header">
          <div className="header-text">
            <h1 className="title lg-view">World of Warcraft Classes and Specs</h1>
            <h1 className="title sm-view">WoW Classes & Specs</h1>
            <div className="description">{pageDescription}</div>
          </div>
        </div>
        <div className="class-boxes-container">
          {CLASSES_AND_SPECS.map((item) => (
            <ClassContainer details={item} key={item.class} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ClassSpecPageContainer;
